import { faFileLines } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { CompanyUploadReference } from 'api/conversations/types'

type Props = {
  reference: CompanyUploadReference
}

export const CompanyUploadHeader = ({
  reference: {
    metadata: { areas, title },
  },
}: Props) => (
  <div className="flex text-base text-default-on-bg-karnovnote">
    <FontAwesomeIcon icon={faFileLines} className="mr-2 mt-0.75" />
    <div className="text-default-on-bg-karnovnote">
      <div className="font-medium [overflow-wrap:anywhere]">{title}</div>
      {areas?.map(area => (<div key={area}>{area}</div>))}
    </div>
  </div>
)
